import { Box, Stack, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";

const BENEFITS = [
  "One place for your studio's boards, concepts and projects",
  "Your own work stays private until you share it",
  "One pool of credits for everyone on the team",
];

/** Left column of the Create team modal (desktop only): what a team gets. */
export const TeamValuePanel = () => (
  <Stack
    spacing={3.5}
    // Gap, not child margins, so the illustration's negative side margins apply.
    useFlexGap
    sx={{
      display: { xs: "none", md: "flex" },
      width: { md: 320, lg: 380 },
      flex: "none",
      boxSizing: "border-box",
      overflow: "hidden",
      bgcolor: "#F5F2FE",
      p: { md: "40px 32px", lg: "44px 40px" },
    }}
  >
    <Typography
      sx={{
        fontSize: 13,
        fontWeight: 600,
        letterSpacing: "0.08em",
        color: "#6B44D6",
      }}
    >
      WHAT YOU GET
    </Typography>

    <Box
      component="img"
      src="/images/create-team-value-v2.png"
      alt=""
      sx={{
        display: "block",
        // Spans the full panel width, into the side padding.
        mx: { md: "-32px", lg: "-40px" },
        width: { md: "calc(100% + 64px)", lg: "calc(100% + 80px)" },
        aspectRatio: "760 / 682",
        // The panel never scrolls: shrink the illustration on short windows so the
        // benefits fit, and drop it once it would be too small to read.
        minHeight: 0,
        objectFit: "contain",
        "@media (max-height: 630px)": { display: "none" },
      }}
    />

    <Stack component="ul" spacing={2.5} sx={{ m: 0, p: 0, listStyle: "none" }}>
      {BENEFITS.map((text) => (
        <Stack
          component="li"
          key={text}
          direction="row"
          spacing={1.75}
          alignItems="flex-start"
        >
          <Box
            sx={{
              flex: "none",
              width: 22,
              height: 22,
              mt: "1px",
              borderRadius: "50%",
              bgcolor: "#9467F0",
              color: "#fff",
              display: "grid",
              placeItems: "center",
            }}
          >
            <CheckIcon sx={{ fontSize: 14 }} />
          </Box>
          <Typography sx={{ fontSize: 16, lineHeight: 1.45 }}>
            {text}
          </Typography>
        </Stack>
      ))}
    </Stack>
  </Stack>
);
